import { IRetailer } from "@faire/web-api--source/indigofair/data/IRetailer";

export const isRetailerOnNetTerms = (retailer: IRetailer | undefined) => {
  return (
    (isRetailerQualifiedForTerms(retailer) &&
      retailer?.maximum_available_payment_term_data?.is_net_terms) ??
    false
  );
};

const isRetailerQualifiedForTerms = (
  retailer: IRetailer | undefined
): boolean => {
  return retailer?.qualified_for_terms ?? false;
};
